import { render, staticRenderFns } from "./TableComponent.vue?vue&type=template&id=73992b9c&scoped=true&lang=pug&"
import script from "./TableComponent.vue?vue&type=script&lang=ts&"
export * from "./TableComponent.vue?vue&type=script&lang=ts&"
import style0 from "./TableComponent.vue?vue&type=style&index=0&id=73992b9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73992b9c",
  null
  
)

export default component.exports